import { useDivisionsMenuQuery } from '@gettactic/hooks';
import * as React from 'react';
import { withFilterProvider } from '../../utils/withFilterProvider';
import { CampusIcon } from '@v2/icons';
import { OfficeSelect } from '@cmp-src/components/selects/OfficeSelect/OfficeSelect';

type Props = {
  onChange: (ids: string[] | string) => void;
  offices?: string[];
  defaultValue?: string;
  disabled?: boolean;
  showSelectedLabel?: boolean;
  allowClear?: boolean;
};

const SelectOfficesBase = ({
  onChange,
  offices = [],
  defaultValue,
  disabled,
  showSelectedLabel = true,
  allowClear = true,
}: Props) => {
  const [selectedValues, setSelectedValues] = React.useState<string[]>(
    offices.length > 0 ? offices : defaultValue ? [defaultValue] : []
  );
  const handleChange = (values: string | string[]) => {
    const arrayedValues = Array.isArray(values)
      ? values
      : values
        ? [values]
        : [];

      setSelectedValues(arrayedValues);
      onChange(arrayedValues);
  };

  const divisions = useDivisionsMenuQuery();

  return (
    <div>
      {divisions.data && (
        <OfficeSelect
          triggerClassName={'text-foreground text-nowrap md:pr-0 md:max-w-[200px] md:truncate'}
          triggerIcon={<CampusIcon className="mr-1 h-4 w-4" />}
          showRemote={false}
          showOOO={false}
          defaultValue={selectedValues[0]}
          divisions={divisions.data}
          onValueChange={handleChange}
          disabled={disabled}
          showSelectedLabel={showSelectedLabel}
          onClear={allowClear ? () => {
            setSelectedValues([]);
            onChange([]);
          } : undefined}
        />
      )}
    </div>
  );
};

// Export the component wrapped with FilterProvider
export const SelectOffices = withFilterProvider(SelectOfficesBase);
